import React, { useState, useEffect } from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { connect } from 'react-redux';
import { goToPage , setTitle, setSelectedSubscriber, getSubscribers, pageLoaded, reportAnalytics} from '../fundialSlice';
import SubscribersList from '../Shared/SubcribersList/SubscribersList';
import { showAppLoader, hideAppLoader } from '../../../Shared/Loader/LoaderSlice';
import { Container, Col, Row } from 'reactstrap';

const SubscriberListPage = (props) => {

  useExtendedEffect((runSideEffects) => { 
    window.scrollTo(0, 0);

    if (runSideEffects()) {
      props.setTitle({titleBold: "בחירת המתנה נעימה" , titleRegular: ""})
      
      props.reportAnalytics({
        eventCategory: 'fundial',
        eventAction: "HN_ChooseClieNum_reveald",
        eventLabel: "",
      });

      props.pageLoaded();
    }
  }, []);

  function  onSelectedSubscriber(subscriber){
    props.setSelectedSubscriber(subscriber);
    props.goToPage({page: 'downloadSongPage'});
  }

  function view() {
    return (
      <Row className='justify-content-md-center'>
        <Col xs='12' sm='12' md='12'>
          <SubscribersList onClickSubscriber={onSelectedSubscriber} />
        </Col>
      </Row>
    );
  }

  return (
    <div className='subscriber-list-page'>
      {view()}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    subscribers: state.fundialPage.subscribers, 
    selectedSubscriber: state.fundialPage.selectedSubscriber,
  };
};

const mapDispatchToProps = {
  goToPage,
  setTitle,
  setSelectedSubscriber,
  getSubscribers,
  showAppLoader,
  hideAppLoader,
  pageLoaded,
  reportAnalytics
};

export default connect(mapStateToProps, mapDispatchToProps)(SubscriberListPage);
